import Accordion from './Accordion';
import InnerAccordionSection from './Accordion/InnerAccordionSection';
import ActionCard from './ActionCard';
import AuthorInfo from './AuthorInfo';
import Breadcrumbs from './Breadcrumbs';
import CardSection from './CardSection';
import ContactCard from './ContactCard';
import CtaBanner from './CtaBanner';
import DocumentDownloadLink from './DocumentDownloadLink';
import Feature from './Feature';
import FeatureVideo from './FeatureVideo';
import CustomisableFooter from './Footer/CustomisableFooter';
import FooterCompliance from './Footer/FooterCompliance';
import RadioInput from './Form/RadioInput';
import DoubleHeader from './Header/DoubleHeader';
import NavMobile from './Header/NavMobile';
import HeroPlain from './Hero/HeroPlain';
import HeroWithMediaAndTriangle from './Hero/HeroWithMediaAndTriangle';
import HeroWithSideImage from './Hero/HeroWithSideImage';
import ImageAndCtaCards from './ImageAndCtaCards';
import ImageAndCtaCard from './ImageAndCtaCards/ImageAndCtaCard';
import InPageNavDesktop from './InPageNav/InPageNavDesktop';
import InPageNavMobile from './InPageNav/InPageNavMobile';
import NavItemDesktop from './InPageNav/NavItemDesktop';
import NavItemMobile from './InPageNav/NavItemMobile';
import InfoBanner from './InfoBanner';
import InfoCard from './InfoCard';
import LazyImg from './LazyImg';
import MiniGuide from './MiniGuide';
import Pagination from './Pagination';
import PageArrow from './Pagination/PageArrow';
import PageNumber from './Pagination/PageNumber';
import ProductCard from './ProductCard';
import ProductCardsContainer from './ProductCard/ProductCardGrid';
import DetailedRelatedContentWithVisibilityToggle from './RelatedContent/DetailedRelatedContentWithVisibilityToggle';
import RelatedContentCard from './RelatedContent/RelatedContentCard';
import ShareWidget from './ShareWidget';
import SplitInfoCard from './SplitInfoCard';
import DesktopPanelButton from './TabPanels/DesktopTabPanels/DesktopPanelButton';
import MobilePanelButton from './TabPanels/MobileTabPanels/MobilePanelButton';
import TableData from './Table/TableData';
import TestimonialWithImage from './TestimonialWithImage';
import TestimonialQuote from './TestimonialWithImage/TestimonialQuote';

export const components = {
  ActionCard,
  Accordion,
  AuthorInfo,
  Breadcrumbs,
  CardSection,
  ContactCard,
  CtaBanner,
  CustomisableFooter,
  DesktopPanelButton,
  DetailedRelatedContentWithVisibilityToggle,
  DocumentDownloadLink,
  DoubleHeader,
  Feature,
  FeatureVideo,
  FooterCompliance,
  HeroPlain,
  HeroWithMediaAndTriangle,
  HeroWithSideImage,
  ImageAndCtaCard,
  ImageAndCtaCards,
  InfoCard,
  InPageNavDesktop,
  InPageNavMobile,
  InnerAccordionSection,
  LazyImg,
  MiniGuide,
  MobilePanelButton,
  NavItemDesktop,
  NavItemMobile,
  NavMobile,
  Pagination,
  PageArrow,
  PageNumber,
  ProductCard,
  ProductCardsContainer,
  RelatedContentCard,
  ShareWidget,
  SplitInfoCard,
  TableData,
  TestimonialQuote,
  TestimonialWithImage,
  RadioInput,
  InfoBanner,
};
